import React, { useEffect, useRef } from "react";
import { Col, InnerWrapper } from "../UI/general";
import { DialBtn, NumberBox, CallSection, DialIcons } from "../UI/dial";
import { css } from "styled-components/macro";
import ButtonsSection from "./statusButtons";
import lstool from "../../utils/localStorage";
const dialNumbers = [
  { value: 1 },
  { value: 2 },
  { value: 3 },
  { value: 4 },
  { value: 5 },
  { value: 6 },
  { value: 7 },
  { value: 8 },
  { value: 9 },
  {
    value: <DialIcons className="md md-account-box-phone"></DialIcons>,
    order: 10,
    customClick: props => {
      props.getNumber();
    }
  },
  { value: 0, order: 11 },
  {
    value: <DialIcons className="md md-tag-backspace"></DialIcons>,
    order: 12,
    customClick: ({ val, setVal }) => {
      if (val !== -1) {
        setVal(val.substr(0, val.length - 1));
      }
    }
  }
];

function Dial(props) {
  const { val, setVal, isLoading, showButtons, name, setStatus } = props;
  let LoadingRef = useRef();
  const Loading = () => {
    LoadingRef.current = setInterval(() => {
      let number = "09";
      for (let i = 0; i < 9; i++) {
        number += Math.floor(Math.random() * 9);
      }
      setVal(number, true);
    }, 70);
  };
  const clickPad = (value, customFn) => {
    const autoGenerate = lstool.get("autoGenerate");
    const access = JSON.parse(lstool.get("userData")).AccessToImport;
    if (autoGenerate !== "true" || access !== "false") {
      if (customFn) {
        customFn(props);
      } else {
        if (val !== -1) {
          setVal(val.length < 11 ? val + value : val);
        } else {
          setVal(value);
        }
      }
    }
  };
  useEffect(() => {
    if (isLoading && !LoadingRef.current) {
      Loading();
    } else if (LoadingRef.current) {
      clearInterval(LoadingRef.current);
      LoadingRef.current = null;
    }
  }, [isLoading]);
  return (
    <InnerWrapper
      css={css`
        flex-grow: 1;
        direction: ltr;
        align-content: center;
        width: unset;
        height: unset;
        overflow-y: auto;
      `}
    >
      <NumberBox setVal={setVal} loading={isLoading} name={name}>
        {val}
      </NumberBox>
      {dialNumbers.map((item, index) => (
        <Col
          key={index}
          size="33.333"
          style={{
            textAlign: "center",
            order: item.order || item.value
          }}
        >
          <DialBtn
            onClick={() => {
              clickPad(item.value, item.customClick);
            }}
          >
            {item.value}
          </DialBtn>
        </Col>
      ))}
      {showButtons ? <ButtonsSection click={setStatus}></ButtonsSection> : null}
    </InnerWrapper>
  );
}
export default Dial;
